export enum ETaskStatus {
  CREATED = 'created',
  PROCESSING = 'processing',
  RECREATED = 'recreated',
  FAILED = 'failed',
  FINISHED = 'finished',
}
